import {createSlice} from '@reduxjs/toolkit'


const currencySlice = createSlice({

    name: 'currency',
    initialState: {
        countFrom: 0,
        countTo: 0,
    },

    reducers: {
        getCountFrom(state,action){
            
           
        }
        
    },
})

export const{getCountFrom} = currencySlice.actions;

export default currencySlice.reducer;